import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Catalogo } from '../../interfaces/general';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ServiciosGeneralesService } from 'projects/modulo-solicitudes/src/core/servicios/servicios-generales.service';
@Component({
  selector: 'app-escolares-laborales',
  templateUrl: './escolares-laborales.component.html',
  styleUrls: ['./escolares-laborales.component.css']
})
export class EscolaresLaboralesComponent implements OnInit {

	@Input() institucionesEducativas: Array<any> = []
	@Input() carreras: Array<Catalogo>
	@Input() Grado_Estudios: Array<Catalogo>
	@Input() situacionesLaborales: Array<Catalogo>
	@Input() oficios: Array<Catalogo>
	@Input() tiposPeriodos: Array<Catalogo>
	@Input() DatosEscolaresLaborales: FormGroup

  escolaresLaboralesFormulario: FormGroup;
	escuelas:any;
	tieneEmpleo: boolean = false;

	  constructor(private serviciosGenerales: ServiciosGeneralesService,
				private snackBar: MatSnackBar,) {

	}

  	ngOnInit(): void {
		// this.listarCarreras(this.institucionesEducativas[0].ID)
		this.obtenerEscuela()
		this.obtenerOficio()
		this.situacionLaboralSeleccionada(+this.DatosEscolaresLaborales.get("DatosLaborales_Ocupacion_ID").value)
		if(this.DatosEscolaresLaborales.get('DatosEscolares_EscuelaID').value != '') {
			console.log(this.DatosEscolaresLaborales.get('DatosEscolares_EscuelaID').value)
			this.obtenerEscuelaID(+this.DatosEscolaresLaborales.get('DatosEscolares_EscuelaID').value)
		}
	}

	ngOnChanges() {
		this.situacionLaboralSeleccionada(this.DatosEscolaresLaborales.get("DatosLaborales_Ocupacion_ID").value)
		if(this.DatosEscolaresLaborales.get('DatosEscolares_EscuelaID').value != '') {
			console.log(this.DatosEscolaresLaborales.get('DatosEscolares_EscuelaID').value)
			this.obtenerEscuelaID(+this.DatosEscolaresLaborales.get('DatosEscolares_EscuelaID').value)
		}

	}

	obtenerEscuelaID(escuelaID) {
		console.log(escuelaID)
		this.serviciosGenerales.getEscuelaID(+escuelaID).subscribe(res => {
			console.log(res)
			this.DatosEscolaresLaborales.get('DatosEscolares_EscuelaID').setValue(res[0])
			this.listarCarreras(res[0].ID)
		})
	}


  	listarCarreras(idEscuela:number) {
		if (idEscuela !== undefined) {
			this.serviciosGenerales.listadoCarreras(idEscuela).subscribe((res) => {
				this.carreras = res
			})
		}
	}

	obtenerOficio () {
		this.DatosEscolaresLaborales.get("DatosLaborales_Ocupacion_ID")
			.valueChanges
			.subscribe((localidad : number) =>{
				this.situacionLaboralSeleccionada(+localidad)
			});
	}

	situacionLaboralSeleccionada(oficio) {

		if (oficio === 1004 || oficio === 1002 || oficio === 1001 || oficio === 1006) {
			this.tieneEmpleo = true;

			this.DatosEscolaresLaborales.get("DatosLaborales_OficioID").setValidators([Validators.required])
			this.DatosEscolaresLaborales.get("DatosLaborales_OficioID").updateValueAndValidity()
			this.DatosEscolaresLaborales.get("DatosLaborales_Empresa").setValidators([Validators.required])
			this.DatosEscolaresLaborales.get("DatosLaborales_Empresa").updateValueAndValidity()
			this.DatosEscolaresLaborales.get("DatosLaborales_IngresosMensuales").setValidators([Validators.required])
			this.DatosEscolaresLaborales.get("DatosLaborales_IngresosMensuales").updateValueAndValidity()
			this.DatosEscolaresLaborales.get("DatosLaborales_Telefono").setValidators([Validators.required])
			this.DatosEscolaresLaborales.get("DatosLaborales_Telefono").updateValueAndValidity()


		} else {
			this.tieneEmpleo = false;
			this.DatosEscolaresLaborales.get("DatosLaborales_OficioID").setValue(null)
			this.DatosEscolaresLaborales.get("DatosLaborales_OficioID").clearValidators()
			this.DatosEscolaresLaborales.get("DatosLaborales_OficioID").updateValueAndValidity()
			this.DatosEscolaresLaborales.get("DatosLaborales_Empresa").setValue('')
			this.DatosEscolaresLaborales.get("DatosLaborales_Empresa").clearValidators()
			this.DatosEscolaresLaborales.get("DatosLaborales_Empresa").updateValueAndValidity()
			this.DatosEscolaresLaborales.get("DatosLaborales_IngresosMensuales").setValue(null)
			this.DatosEscolaresLaborales.get("DatosLaborales_IngresosMensuales").clearValidators()
			this.DatosEscolaresLaborales.get("DatosLaborales_IngresosMensuales").updateValueAndValidity()
			this.DatosEscolaresLaborales.get("DatosLaborales_Telefono").setValue(null)
			this.DatosEscolaresLaborales.get("DatosLaborales_Telefono").clearValidators()
			this.DatosEscolaresLaborales.get("DatosLaborales_Telefono").updateValueAndValidity()

			this.DatosEscolaresLaborales.updateValueAndValidity()

		}
	}

	displayEscuela(value) {
		if(value === null) {
			return ''
		}else {
			return typeof value === 'object' ? value.Nombre : value
		}

	}

	obtenerEscuela () {
		this.DatosEscolaresLaborales.get("DatosEscolares_EscuelaID")
			.valueChanges
			.subscribe((escuela : string) =>{

				this.filtrar(escuela)
			});
	}
	filtrar(escuela) {

		if(escuela !== null) {
			if (escuela.length >=4) {

				this.serviciosGenerales.verEscuelas(escuela).subscribe(res => {
					this.institucionesEducativas = res
					this.DatosEscolaresLaborales.get('DatosEscolares_CarreraID').setValue(null)
					this.listarCarreras(this.institucionesEducativas[0].ID)
				})

		}
		}


	}

	revisarCampo() {
		if (typeof(this.DatosEscolaresLaborales.controls['DatosEscolares_EscuelaID'].value) !== 'object') {
			this.DatosEscolaresLaborales.controls['DatosEscolares_EscuelaID'].setValue(null);
			this.openSnackBar('Debe de selecionar al menos una opcion','Entendido')
		}
	}
	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
			duration: 6000,
		});
	}


}
